import { useMemo } from "react";

import { useGetOtherNetworks } from "./queries";

const useOtherNetworks = () => {
  const { data: { otherNetworks = {} } = {} } = useGetOtherNetworks();

  return useMemo(() => Object.values(otherNetworks), [otherNetworks]);
};

export { useOtherNetworks };
